import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { homePathFor } from '../auth/home-path.js';

export function LandingPage() {
  const { login, isAuthenticated, isLoading, role, activeRole, roleCatalogue } = useAuth();

  // Opening a second tab to "/" with a live session shouldn't strand
  // the user on a Sign-In screen — /api/me already proves we're logged
  // in via the bluforce_sid cookie. Send them to their role's home.
  if (isLoading) return null;
  if (isAuthenticated) {
    return <Navigate to={homePathFor(activeRole ?? role, roleCatalogue)} replace />;
  }

  return (
    <div className="d-flex align-items-center min-vh-100 bg-light py-4">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center mb-5">
            <h1 className="display-4 mb-1">
              <em style={{ fontFamily: 'Georgia, serif', fontWeight: 'bold' }}>
                Wawanesa
              </em>{' '}
              <span className="text-primary">Life</span>
            </h1>
            <p className="text-secondary fs-5">Life Insurance Platform</p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={4} className="text-center">
            <Card className="shadow-sm border-0">
              <Card.Body className="p-5">
                <p className="text-secondary mb-4">
                  Sign in to access quotes, illustrations, and applications
                </p>
                <Button
                  variant="primary"
                  size="lg"
                  className="px-5 py-2 fw-semibold"
                  onClick={login}
                  aria-label="Sign in to BluForce"
                >
                  Sign In
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
